import React, { useEffect, useRef } from "react";
import { Mail, Smartphone, Globe, ExternalLink, Instagram, Linkedin, Code, Cpu, Network } from "lucide-react";
import "./reachdeveloper.css";

const ReachDeveloper = () => {
  const cardRef = useRef(null);

  // Subtle magnetic hover effect for the main container
  useEffect(() => {
    const card = cardRef.current;
    if (!card) return;

    const handleMouseMove = (e) => {
      const rect = card.getBoundingClientRect();
      const x = e.clientX - rect.left - rect.width / 2;
      const y = e.clientY - rect.top - rect.height / 2;

      // Calculate rotation for 3D effect based on cursor position
      const rotateX = (y / rect.height) * -8;
      const rotateY = (x / rect.width) * 8;

      card.style.setProperty("--rotateX", `${rotateX}deg`);
      card.style.setProperty("--rotateY", `${rotateY}deg`);
    };

    const handleMouseLeave = () => {
      card.style.setProperty("--rotateX", "0deg");
      card.style.setProperty("--rotateY", "0deg");
    };

    card.addEventListener("mousemove", handleMouseMove);
    card.addEventListener("mouseleave", handleMouseLeave);

    return () => {
      card.removeEventListener("mousemove", handleMouseMove);
      card.removeEventListener("mouseleave", handleMouseLeave);
    };
  }, []);

  return (
    <div className="rd-premium-page">
      {/* Animated Background Orbs */}
      <div className="rd-ambient-orb orb-1"></div>
      <div className="rd-ambient-orb orb-2"></div>
      <div className="rd-ambient-orb orb-3"></div>

      <div className="rd-hero-container">

        <div className="rd-header-section reveal-up">
          <div className="rd-badge">
            <Cpu size={14} /> Developer Core
          </div>
          <h1 className="rd-hero-title">Engineering <span className="text-gradient">Excellence</span></h1>
          <p className="rd-hero-subtitle">
            Crafting scalable, high-performance web applications and cutting-edge digital infrastructure.
          </p>
        </div>

        <div className="rd-glass-card reveal-up delay-1" ref={cardRef}>
          <div className="rd-card-grid">

            {/* Left Column: Profile */}
            <div className="rd-profile-col">
              <div className="rd-profile-image-container">
                <div className="rd-image-glow"></div>
                <img
                  src="https://res.cloudinary.com/dexueorjm/image/upload/v1772717911/Sailu_aettari2_mhs6r6.png"
                  alt="Tech Nanisai"
                  className="rd-profile-img"
                />
                <div className="rd-floating-icon fl-1"><Code size={20} /></div>
                <div className="rd-floating-icon fl-2"><Network size={20} /></div>
              </div>

              <div className="rd-profile-info">
                <h2>Tech Nanisai</h2>
                <h3 className="rd-role-gradient">Advanced Full Stack Developer</h3>
                <p className="rd-bio">
                  Specializing in complex system architecture, responsive frontend engineering, and robust backend integrations to build platforms that scale flawlessly.
                </p>
              </div>
            </div>

            {/* Right Column: Interactive Links */}
            <div className="rd-links-col">
              <h4 className="rd-connect-heading">Connect & Collaborate</h4>
              <div className="rd-links-grid">

                {/* Email */}
                <a href="mailto:nanisaiofficial5@gmail.com" className="rd-link-box">
                  <div className="rd-link-icon mail">
                    <Mail size={22} />
                  </div>
                  <div className="rd-link-content">
                    <span className="rd-link-label">Direct Mail</span>
                    <span className="rd-link-value">nanisaiofficial5@gmail.com</span>
                  </div>
                  <ExternalLink size={16} className="rd-arrow-out" />
                </a>

                {/* Phone */}
                <a href="tel:+919948946658" className="rd-link-box">
                  <div className="rd-link-icon phone">
                    <Smartphone size={22} />
                  </div>
                  <div className="rd-link-content">
                    <span className="rd-link-label">Call / WhatsApp</span>
                    <span className="rd-link-value">+91 99489 46658</span>
                  </div>
                  <ExternalLink size={16} className="rd-arrow-out" />
                </a>

                {/* Portfolio */}
                <a href="https://www.nxorsystems.com/" target="_blank" rel="noopener noreferrer" className="rd-link-box">
                  <div className="rd-link-icon globe">
                    <Globe size={22} />
                  </div>
                  <div className="rd-link-content">
                    <span className="rd-link-label">Portfolio Network</span>
                    <span className="rd-link-value">www.nxorsystems.com</span>
                  </div>
                  <ExternalLink size={16} className="rd-arrow-out" />
                </a>

                {/* LinkedIn */}
                <a href="https://www.linkedin.com/in/aettarisailu/" target="_blank" rel="noopener noreferrer" className="rd-link-box">
                  <div className="rd-link-icon linkedin">
                    <Linkedin size={22} />
                  </div>
                  <div className="rd-link-content">
                    <span className="rd-link-label">Professional Profile</span>
                    <span className="rd-link-value">aettarisailu</span>
                  </div>
                  <ExternalLink size={16} className="rd-arrow-out" />
                </a>

                {/* Instagram */}
                <a href="https://www.instagram.com/a.nanisai/" target="_blank" rel="noopener noreferrer" className="rd-link-box">
                  <div className="rd-link-icon instagram">
                    <Instagram size={22} />
                  </div>
                  <div className="rd-link-content">
                    <span className="rd-link-label">Social Feed</span>
                    <span className="rd-link-value">@a.nanisai</span>
                  </div>
                  <ExternalLink size={16} className="rd-arrow-out" />
                </a>

              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default ReachDeveloper;
